
export type FilterByTypeParamParameter = typeof FilterByTypeParamParameter[keyof typeof FilterByTypeParamParameter];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FilterByTypeParamParameter = {
  USER: 'USER',
  ENROLLED: 'ENROLLED',
  POPULAR: 'POPULAR',
  ROADMAP: 'ROADMAP',
  FORYOU: 'FORYOU',
  MY_PUBLISHED: 'MY_PUBLISHED',
} as const;
